import { getTotal } from "./utils";

export const competitorPerformance = ({ report, brands }) => {
  const filteredBrands = brands.filter(
    (item) =>
      ![
        "Competitor 1",
        "Competitor 2",
        "Competitor 3",
        "Competitor 4",
      ].includes(item)
  );
  return [
    {
      id: "cp_traffic",
      chartBlock: {
        title: "Share of Estimated Yearly Traffic",
        description:
          "This section shows how website traffic is distributed among key competitors in the market. The data reveals current market position by displaying estimated annual clicks and percentage share for each competitor. This competitive landscape view helps understand relative performance and identifies the size of opportunity available by analyzing competitor traffic volumes that could potentially be captured through improved optimization strategies.",
        cols: ["Websites", "Est. Current Clicks", "% share"],
        fields: ["websites", "clicks", "share"],
        sortField: "clicks",
        sortOrder: -1,
        comp: true,
      },
    },
    {
      id: "cp_keyword_gaps",
      chartBlock: {
        title: "Keyword Gaps",
        description: `This analysis identifies keyword opportunities by comparing performance against competitors across different strength categories. "Untapped" keywords represent the largest opportunity where competitors rank but the website doesn't appear. The gap categories (Missing, Weak, Shared, Strong) help prioritize which keywords to target first, with untapped keywords typically offering the quickest wins for expanding search visibility and capturing new traffic.`,
        desc: (
          <div
            style={{
              lineHeight: "normal",
              marginTop: "30px",
              paddingLeft: "10px",
            }}
          >
            <p>
              <b>Untapped</b> = We don't rank but at least one competitor does
            </p>
            <p>
              <b>Shared</b> = Us and every competitor ranks
            </p>
            <p>
              <b>Strong</b> = We rank better than every competitor
            </p>
            <p>
              <b>Weak</b> = We rank but lower than every competitor
            </p>
            <p>
              <b>Missing</b> = We don't rank but all competitors do
            </p>
          </div>
        ),
        cols: ["Label", "Gaps"],
        fields: ["label", "gaps"],
        sortField: "gaps",
        sortOrder: 1,
        swap: true,
      },
    },
    {
      id: "cp_comp_rankings",
      tableBlock: {
        title: "Competitor Rankings",
        description:
          "This table compares average search ranking positions across different product categories against key competitors. Lower numbers indicate better rankings, so this view quickly identifies categories where the website leads or lags behind competition. Categories showing significantly higher numbers than competitors represent optimization priorities, while strong-performing categories indicate successful strategies that could be replicated elsewhere.",
        cols: ["Category", ...filteredBrands],
        fields: ["category", ...filteredBrands],
        sortField: brands[0],
        sortOrder: -1,
        paginator: true,
        container: true,
      },
    },
    {
      id: "cp_comp_traffic",
      tableBlock: {
        title: "Competitor Estimated Yearly Traffic",
        description:
          "his section estimates actual traffic volumes that competitors are receiving for different product categories. The numbers show estimated annual clicks each competitor captures, helping quantify the traffic opportunity in each category. Categories where competitors show high traffic but the website shows zero or low numbers represent significant growth opportunities through improved search optimization.",
        cols: ["Category", ...filteredBrands],
        fields: ["category", ...filteredBrands],
        sortField: brands[0],
        sortOrder: -1,
        paginator: true,
        footer: [
          "Grand Total",
          brands[0]
            ? getTotal({ report, sheet: "cp_comp_traffic", field: brands[0] })
            : null,
          brands[1] && brands[1] !== "Competitor 1"
            ? getTotal({ report, sheet: "cp_comp_traffic", field: brands[1] })
            : null,
          brands[2] && brands[2] !== "Competitor 2"
            ? getTotal({ report, sheet: "cp_comp_traffic", field: brands[2] })
            : null,
          brands[3] && brands[3] !== "Competitor 3"
            ? getTotal({ report, sheet: "cp_comp_traffic", field: brands[3] })
            : null,
          brands[4] && brands[4] !== "Competitor 4"
            ? getTotal({ report, sheet: "cp_comp_traffic", field: brands[4] })
            : null,
        ],
        container: true,
      },
    },
    {
      id: "cp_comp_revenue",
      tableBlock: {
        title: "Competitor Estimated Yearly Revenue",
        cols: ["Category", ...filteredBrands],
        fields: ["category", ...filteredBrands],
        sortField: brands[0],
        sortOrder: -1,
        footer: [
          "Grand Total",
          brands[0]
            ? getTotal({ report, sheet: "cp_comp_revenue", field: brands[0] })
            : null,
          brands[1] && brands[1] !== "Competitor 1"
            ? getTotal({ report, sheet: "cp_comp_revenue", field: brands[1] })
            : null,
          brands[2] && brands[2] !== "Competitor 2"
            ? getTotal({ report, sheet: "cp_comp_revenue", field: brands[2] })
            : null,
          brands[3] && brands[3] !== "Competitor 3"
            ? getTotal({ report, sheet: "cp_comp_revenue", field: brands[3] })
            : null,
          brands[4] && brands[4] !== "Competitor 4"
            ? getTotal({ report, sheet: "cp_comp_revenue", field: brands[4] })
            : null,
        ],
        container: true,
      },
    },
  ];
};
